<template>
  <div class="about DivImage" :style="{background: 'url('+ backgroungImg +') no-repeat'}">
    <img class="top-logo" :src="Logo" :style="{top: '35px', left: '16%'}">
    <info-header :type="'3'"></info-header>
    <div class="infoGroup" :class="isScroll ? 'flexGroup' : 'group'" :style="{marginTop: '60px'}">
      <div id="Editor"></div>
    </div>
    <info-footer></info-footer>
  </div>
</template>

<script>
import InfoHeader from '../components/aboutHeader.vue'
import InfoFooter from '../components/aboutFooter.vue'
import Logo from '../assets/image/FTG-aboutLogo.jpg'

import E from 'wangeditor'

export default {
  name: 'About',
  components: {
    InfoHeader, InfoFooter
  },
  data () {
    return {
      token: window.sessionStorage.getItem('token'),
      Logo: Logo,
      backgroungImg: '',
      backgroungImgArr: [],
      bgIndex: 0,
      timer: null,
      isScroll: true
    }
  },
  methods: {
    
  },
  computed: {
    
  },
  mounted() {
    const that = this


    // 创建富文本编辑器
    that.editor = new E('#Editor');

    // 配置服务器端地址
    that.editor.customConfig.uploadImgServer = `${process.env.API_HOST}/upload/index.php`;
    // 将图片大小限制为 10M
    that.editor.customConfig.uploadImgMaxSize = 1024 * 1024 * 10;
    
    that.editor.customConfig.uploadFileName = 'imageFile';
    that.editor.customConfig.uploadImgHooks = {
      // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
      // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
      customInsert: function (insertImg, result, editor) {
        var url = result.pic;
        insertImg(url)
      }
    }
    that.editor.customConfig.customAlert = function (info) {
      // info 是需要提示的内容
      that.$Message.warning(info);
    }
    
    // 自定义菜单配置
    that.editor.customConfig.menus = [
      'head',  // 标题
      'bold',  // 粗体
      'fontSize',  // 字号
      'fontName',  // 字体
      'italic',  // 斜体
      'underline',  // 下划线
      'strikeThrough',  // 删除线
      'foreColor',  // 文字颜色
      'backColor',  // 背景颜色
      'link',  // 插入链接
      'list',  // 列表
      'justify',  // 对齐方式
      'quote',  // 引用
      'emoticon',  // 表情
      'image',  // 插入图片
      'table',  // 表格
      'code',  // 插入代码
      'undo',  // 撤销
      'redo'  // 重复
    ]
    // 字体
    that.editor.customConfig.fontNames = [
      '宋体',
      '微软雅黑',
      'Arial',
      'Tahoma',
      'Verdana',
      'Georgia',
      'Lucida Grande',
      'Times New Roman',
      'Comic Sans MS',
      'Time News Roman',
      'fantasy',
      'HYChengXingJ'
    ]

    that.editor.create();
    document.querySelector("#Editor .w-e-text").contentEditable = false;

    setTimeout(function(){
      var EditorH = document.querySelector('#Editor');
      this.isScroll =  ((EditorH.clientHeight + 60) > window.innerHeight)
    },200)

    
  },
  created(){
    const that = this
    let Data = {
      // token: that.token
    }
    that.$api.getAboutInfo(Data).then(res => {
      if(res.rescode == 0){
        that.editor.txt.html(res.about);

        that.backgroungImgArr = res.aboutUrl
        if(that.backgroungImgArr && that.backgroungImgArr.length > 0){
          that.backgroungImg = that.backgroungImgArr[that.bgIndex].url
        }else{
          // that.backgroungImg = that.BgDefault
        }

        that.timer = setInterval(function() {
          if(that.backgroungImgArr && that.backgroungImgArr.length > 0){
            that.backgroungImg = that.backgroungImgArr[that.bgIndex].url
            
            if(that.bgIndex == that.backgroungImgArr.length - 1){
              that.bgIndex = 0
            }else{
              that.bgIndex ++
            }
          }else{
            clearInterval(that.timer);
          }
        }, 10000);
      }
    }).catch(err => {});
  },
  beforeRouteLeave (to, from, next) {
    if(this.timer) { //如果定时器还在运行 或者直接关闭，不用判断
      clearInterval(this.timer); //关闭
    }
    next()
  }
}
</script>

<style scoped lang="less">
  @import '../assets/css/main.less';
</style>



// WEBPACK FOOTER //
// src/pages/about.vue